import type { FC } from 'react'
import styled from 'styled-components'

import Checkbox from '@/components/Checkbox'
import Detail from '@/components/Detail'
import H4 from '@/components/H4'
import Select from '@/components/Select'
import type { SelectOption } from '@/components/Select'

export type ContactTypeT = 'connected' | 'voicemail' | 'notConnected'

const selectOptions: SelectOption<ContactTypeT>[] = [
  {
    label: 'Connected',
    value: 'connected',
  },
  {
    label: 'Voicemail',
    value: 'voicemail',
  },
  {
    label: 'Not Connected',
    value: 'notConnected',
  },
]

export interface SubjectContactT {
  callWasPlaced: boolean
  contactType: ContactTypeT
}

export const DEFAULT_VALUES: SubjectContactT = {
  callWasPlaced: false,
  contactType: 'connected',
}

const DetailWrapper = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(2, 1fr);
`

interface Props {
  contactName: string
  subjectName: string
  phoneNumber: string
  subjectContact: SubjectContactT
  onChangeSubjectContact: (subjectContact: SubjectContactT) => void
}

const SubjectContact: FC<Props> = ({
  contactName,
  subjectName,
  phoneNumber,
  subjectContact,
  onChangeSubjectContact,
}) => (
  <>
    <H4>{subjectName}</H4>
    <DetailWrapper>
      <Detail label="Contact Name">{contactName}</Detail>
      <Detail label="Phone number">{phoneNumber}</Detail>
    </DetailWrapper>
    <Checkbox
      label="I placed a call"
      checked={subjectContact.callWasPlaced}
      onChange={e =>
        onChangeSubjectContact({
          ...subjectContact,
          callWasPlaced: e.target.checked,
        })
      }
    />
    {subjectContact.callWasPlaced && (
      <Select<ContactTypeT>
        options={selectOptions}
        selectedValue={subjectContact.contactType}
        onSelect={contactType =>
          onChangeSubjectContact({
            ...subjectContact,
            contactType,
          })
        }
      />
    )}
  </>
)

export default SubjectContact
